// External modules
import acHTTPClient from 'services/ACHTTPClient';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;

const getStoryboardsByProviderIdError = error => {
  return {
    type: constants.GET_STORYBOARDS_BY_PROVIDER_ID_ERROR,
    error,
  };
};

const getStoryboardsByProviderIdSuccess = storyboards => {
  return {
    type: constants.GET_STORYBOARDS_BY_PROVIDER_ID_SUCCESS,
    storyboards: storyboards,
  };
};

const getStoryboardByIdError = error => {
  return {
    type: constants.GET_STORYBOARD_BY_ID_ERROR,
    error,
  };
};

const getStoryboardByIdSuccess = storyboards => {
  return {
    type: constants.GET_STORYBOARD_BY_ID_SUCCESS,
    storyboards: storyboards,
  };
};

const getStoryboardsByProviderId = (providerId, isNotInactive) => {
  let apiURL = `${experienceAPIURL}/providers/${providerId}/storyboards`;
  if (isNotInactive) {
    apiURL += '?isNotInactive=true';
  }
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getStoryboardsByProviderIdError(response.statusText));
        }
        dispatch(getStoryboardsByProviderIdSuccess(response.data));
      })
      .catch(error => {
        dispatch(getStoryboardsByProviderIdError(error));
      });
  };
};

const getStoryboardById = id => {
  let apiURL = `${experienceAPIURL}/storyboards/${id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(getStoryboardByIdError(response.statusText));
        }
        dispatch(getStoryboardByIdSuccess(response.data));
      })
      .catch(error => {
        dispatch(getStoryboardByIdError(error));
      });
  };
};

const postStoryboardError = error => {
  return {
    type: constants.POST_STORYBOARD_ERROR,
    error,
  };
};

const postStoryboardSuccess = newId => {
  return {
    type: constants.POST_STORYBOARD_SUCCESS,
    newId: newId,
  };
};

const postStoryboard = newStoryboard => {
  let apiURL = `${experienceAPIURL}/storyboards`;
  return dispatch => {
    const config = { url: apiURL, method: 'POST', data: newStoryboard };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(postStoryboardError(response.statusText));
        }
        dispatch(postStoryboardSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(postStoryboardError(error));
      });
  };
};

const patchStoryboardError = error => {
  return {
    type: constants.PATCH_STOP_ERROR,
    error,
  };
};

const patchStoryboardSuccess = storyboard => {
  return {
    type: constants.PATCH_STORYBOARD_SUCCESS,
    storyboard: storyboard,
  };
};

const patchStoryboard = storyboard => {
  let apiURL = `${experienceAPIURL}/storyboards/${storyboard.id}`;
  return dispatch => {
    const config = { url: apiURL, method: 'PATCH', data: storyboard };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(patchStoryboardError(response.statusText));
        }
        dispatch(patchStoryboardSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(patchStoryboardError(error));
      });
  };
};

const deleteStoryboardError = error => {
  return {
    type: constants.DELETE_STORYBOARD_ERROR,
    error,
  };
};

const deleteStoryboardSuccess = newId => {
  return {
    type: constants.DELETE_STORYBOARD_SUCCESS,
    newId: newId,
  };
};

const deleteStoryboard = storyboardId => {
  let apiURL = `${experienceAPIURL}/storyboards/${storyboardId}`;
  return dispatch => {
    const config = { url: apiURL, method: 'DELETE' };
    acHTTPClient
      .request(config)
      .then(response => {
        if (!response.data || response.data.error) {
          dispatch(deleteStoryboardError(response.statusText));
        }
        dispatch(deleteStoryboardSuccess(response.data));
      })
      .catch(error => {
        onAuthError(error);
        dispatch(deleteStoryboardError(error));
      });
  };
};

export { getStoryboardsByProviderId, getStoryboardById, postStoryboard, patchStoryboard, deleteStoryboard };
